import { PayrollProvider } from '@neo.tax/shared/graphql';
import { interpretTabularDataParseError } from '@neo.tax/shared/utils';

import { ConnectProvider } from './ConnectProvider';
import { useSyncPayrollProvider } from './hooks';

interface ConnectPayrollProps {
  providerName: PayrollProvider;
  close: () => void;
  restart: () => void;
  fiscalYearId: string;
}

export const ConnectPayroll = ({
  close,
  fiscalYearId,
  providerName,
  restart,
}: ConnectPayrollProps): React.ReactElement => {
  const { connect, connectStatus, errors } = useSyncPayrollProvider({ fiscalYearId, providerName });
  const errorMessages = errors?.map((error) => interpretTabularDataParseError(error));

  return (
    <ConnectProvider
      close={close}
      restart={restart}
      connect={connect}
      connectStatus={connectStatus}
      errorMessages={errorMessages}
      provider={{ providerName, providerType: 'payroll' }}
    />
  );
};
